module.exports = __webpack_public_path__ + "img/fireNo.9dab44af.png";